export default class scrollSticky {
    constructor() {
        return {
            restrict: 'A',
            transclude: true,
            template: '<div class="stickyParent" ng-transclude></div><div class="stickyChild col-md-12" ng-transclude></div>',
            controller: StickyScrollCtrl,
            controllerAs: 'follower'
        }
    }
};

class StickyScrollCtrl {
    constructor($element, $window) {
        this.stickyChild = $element.find('.stickyChild');
        this.stickyChild.hide()

        $('.viewport').find('.content').addClass('stickyPadding');

        angular.element($window).bind('scroll', () => {
            this.onScreen($element) ? this.stickyChild.hide() : this.stickyChild.show();
        });
    }

    onScreen(elem) {
        let $window = $(window);
        let viewportTop = $window.scrollTop()
        let viewportHeight = $window.height()
        let viewportBottom = viewportTop + viewportHeight
        let $elem = $(elem)
        let top = $elem.offset().top
        let height = $elem.height()
        let bottom = top + height

        return (top >= viewportTop && top < viewportBottom) ||
            (bottom > viewportTop && bottom <= viewportBottom) ||
            (height > viewportHeight && top <= viewportTop && bottom >= viewportBottom)
    }
}
